module.exports = __webpack_public_path__ + "static/media/nexstack.e5063fa1.png";